// --
import React from 'react';
import {Col, Row} from "reactstrap";
import AbstractField from "./AbstractField";
import "./ListSelectField.scss";
import classNames from "classnames";
import "./ImageSelectField.scss";
import getMapFromList from "../utils/getMapFromList";
import Image from "../image/Image";

/**
 * Komponenta seznamu položek - seznam obrázků s možností jednu vybrat kliknutím na checkbox.
 */
class ImageSelectField extends AbstractField {
    static PropTypes = {
        items: React.PropTypes.array.isRequired, // seznam položek
        idAttrName: React.PropTypes.string,  // název atributu pro určení id
        renderItem: React.PropTypes.func,   // render obrázku - předpis: () => {item, checked, disabled, onClick, onCheck}
        onClick: React.PropTypes.func,   // klik na obrázek - např. pro možnost akce zobrazení náhledu apod.
        multiple: React.PropTypes.bool, // pokud je true, jedná se o výběr více položek
        fromIndex: 4, // od jakého indexu položky zobrazovat, pokud je 0, jsou zobrazovány od začátku, např pro stránkování
        count: 4, // maximální počet položek zobrazených položek, např pro stránkování, pokud je 0, zobrazují se všechny
    };

    static defaultProps = {
        multiple: false,
        idAttrName: "id",
        srcAttrName: "src",
        fromIndex: 0,
        count: 0,
        colProps: {
            xs: 12,
            md: 3
        }
    };

    handleChange = (item) => {
        const {multiple, idAttrName, onChange, value} = this.props;

        if (multiple) {
            const useValue = value || [];
            const map = getMapFromList(useValue);
            if (map[item[idAttrName]]) {
                delete map[item[idAttrName]];
            } else {
                map[item[idAttrName]] = item;
            }
            onChange(Object.values(map));
        } else {
            onChange(item);
        }
    };

    renderImage = (item, index, active) => {
        const {renderItem, srcAttrName, onClick, disabled} = this.props;

        const onClickFc = () => onClick(item, index);
        const onCheckFc = () => this.handleChange(item);

        if (renderItem) {
            return renderItem(item, active, disabled, onClickFc, onCheckFc);
        } else {
            return <Image checked={active} src={item[srcAttrName]} disabled={disabled} onClick={onClickFc} onCheck={onCheckFc} />;
        }
    };

    render() {
        const {fromIndex, count, colProps, multiple, className, classNameRow, idAttrName, srcAttrName, value, items, onClick} = this.props;
        const cls = classNames("image-select-field", className, classNameRow);

        const images = [];
        for (let a=fromIndex; (count === 0 || a<fromIndex + count) && a < items.length; a++) {
            const item = items[a];
            let active;
            if (item && value != null) {
                if (multiple) {
                    const useValue = value || [];
                    const map = getMapFromList(useValue);
                    active = map[item[idAttrName]];
                } else {
                    active = item[idAttrName] === value[idAttrName];
                }
            }

            let useColProp;
            if (Array.isArray(colProps)) {
                useColProp = colProps[a - fromIndex];
            } else {
                useColProp = colProps;
            }

            images.push(
                <Col {...useColProp} key={item ? item[idAttrName] : -1} className={active ? "active" : ""}>
                    {item && this.renderImage(item, a, active)}
                </Col>
            );
        }

        let field;

        // TODO slapa: vyřešit lépe - správně
        if (count === 8) {
            const imagesA = [];
            const imagesB = [];

            images.forEach((i, c) => {
                if (c < 4) {
                    imagesA.push(i);
                } else {
                    imagesB.push(i);
                }
            });

            field = <Row className={cls}>
                <Col xs={12} md={6}>
                    <Row className={cls}>
                        {imagesA}
                    </Row>
                </Col>
                <Col xs={12} md={6}>
                    <Row className={cls}>
                        {imagesB}
                    </Row>
                </Col>
            </Row>;
        } else {
            field = <Row className={cls}>
                {images}
            </Row>;
        }

        return this.renderFieldWithAddons(field);
    }
}

export default ImageSelectField;
